import { isArray } from 'lodash';

export default function setChallengesCompletedCount(quest) {
  const { subQuests } = quest;
  if (!isArray(subQuests)) return { ...quest, completedCount: 0 };
  const completedQuestsCount = subQuests.reduce((acc, quest) => acc + +(quest.isComplete && !quest.isCollected), 0);
  return { ...quest, completedCount: completedQuestsCount };
}
